import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../theme';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { withStyles } from '@material-ui/core/styles';

import PrintIcon from '@material-ui/icons/Print';
import BtnLabel from './buttons/UserBarLabelButton';

import AddressSearchPaper from './AddressSearchPaper';
import MapSharePaper from './MapSharePaper';
import BaseLayerPaper from './BaseLayerPaper';
import MapToolsPaper from './MapToolsPaper';
import MapLayerPaper from './MapLayersPaper';
import { SessionContext } from "../context/session-context";
import { BalanceContext } from "../context/balance-context";

import Tooltip from '@material-ui/core/Tooltip';
import { FormatColorReset, FormatListBulletedSharp } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    background: 'white',
    color: 'white',
  },

  menuButton: {
    color: '#273090',
      '&:hover': {
        color: '#F9AF44'
      }
  },
  logo: {
    width: 300,
  },
  toolbar: {
    background: 'white',
    minHeight: 40,
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  searchContainer: {
    flexGrow: 1,
  },
  optionsContainer: {
    flexGrow: 1,
  },
  layerContainer: {

  },
});

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default function UserBar(props) {

  const [sState, sDispatch] = useContext(SessionContext);
  const classes = useStyles(props);

  const [isPrint, setIsPrint] = useState(false);
  const [isExport, setIsExport] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [isTools, setIsTools] = useState(false);
  const [isToolsDisabled, setIsToolsDisabled] = useState(false);
  const [isLayers, setIsLayers] = useState(false);

  const setAction = (action) => {
    sDispatch({
      type: "setUserAction",
      payload: { action: action}
    });
  };

  useEffect(() => {
    setDisplayAction(sState.caction);
  },[sState.caction]);

  function setDisplayAction(action){
    //console.log("Menu selection action: "+action);

    switch(action){
      case "clear":
      case "addressresult":
        setIsPrint(false);
        setIsExport(false);
        setIsReport(false);
        setIsLayers(false);
      break;
      case "print":
        setIsPrint(true);
        setIsExport(false);
        setIsReport(false);
        setIsLayers(false);
        setIsTools(false);
        setIsToolsDisabled(true);
      break;
      case "endprint":
        setIsPrint(false);
        setIsExport(false);
        setIsReport(false);
        setIsLayers(false);
        setIsTools(false);
        setIsToolsDisabled(false);
      break;
      case "export":
        setIsExport(true);
        setIsPrint(false);
        setIsReport(false);
        setIsTools(false);
        setIsToolsDisabled(true);
        setIsLayers(false);
      break;
      case "endexport":
        setIsExport(false);
        setIsPrint(false);
        setIsReport(false);
        setIsTools(false);
        setIsToolsDisabled(false);
        setIsLayers(false);
      break;
      case "report":
        setIsReport(true);
        setIsPrint(false);
        setIsExport(false);
        setIsTools(false);
        setIsToolsDisabled(true);
        setIsLayers(false);
      break;
      case "layers":
        setIsReport(false);
        setIsPrint(false);
        setIsExport(false);
        setIsTools(false);
        setIsLayers(true);
      break;
      case "tools":
        setIsTools(true);
        //setIsLayers(false);
      break;
      case "endtools":
        setIsTools(false);
        //console.log("set istools to false.");
      break;
      
      default:
        break;
    }
  }

  /**
   * Clear all menu options.
   */
  function clearActions(){
    setIsToolsDisabled(false);
    setIsPrint(false);
    setIsExport(false);
    setIsReport(false);
    setIsTools(false);
    setIsLayers(false);
  }

  const handlePrint = () => {
    if (!isPrint) { setDisplayAction('print'); setAction('print'); } else { setAction('endprint'); }//clearActions();
  };
  const handleExport = () => {
    if (!isExport) { setDisplayAction('export'); setAction('export'); } else { setAction('endexport'); } //clearActions();}
  };
  const handleReport = () => {
    if (!isReport) { setDisplayAction('report'); setAction('report'); } else { setAction('endreport'); clearActions(); }
  };

  const handleLayers = () => {
    if (!isLayers) { setDisplayAction('layers'); setAction('displaylayers'); } else { setAction('endlayers'); clearActions(); }
    
  };
  const handleTools = () => {
    if (!isTools) { setDisplayAction('tools'); setAction('displaytools');  } else { setAction('endtools'); clearActions(); }
    
  };

 //<MapSharePaper className={classes.layerContainer} />
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.toolbar}>
            <AddressSearchPaper className={classes.searchContainer}/>
            <div className={classes.optionsContainer}>
              <BtnLabel label="Print" selected={isPrint} handleChange={handlePrint} disabled={false} tooltip={'To order printed map.'} />
              <BtnLabel label="Export" selected={isExport} handleChange={handleExport} disabled={false} tooltip={'To order data for download.'} />
            </div>
            { sState.isActive ? <BaseLayerPaper className={classes.layerContainer} /> : '' }
            <MapToolsPaper selected={isTools} disabled={isToolsDisabled} handleChange={handleTools} className={classes.layerContainer} tooltip={'Markup tools for your map'}/>
            <MapLayerPaper selected={isLayers} disabled={false} handleChange={handleLayers} className={classes.layerContainer} tooltip={'Data layers'}/>
        </Toolbar>
      </AppBar>
    </div>
  );
};
